export const SESSION_STATUS = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  CONFIRMING_ANSWER: 'CONFIRMING_ANSWER',
  READY_TO_GRADE: 'READY_TO_GRADE', // The status when all questions have already been done/viewed but not yet graded.
  GRADE: 'GRADE', // The status when graing.
  GRADED: 'GRADED', // The status when everything is done and graded
  TIMEOUT: 'TIMEOUT',
};
